import React from 'react'
import {
  InvestmentButton,
  InvestmentCardContainer,
  InvestmentCardSubtitle,
  InvestmentCardTitle,
  InvestmentLegend
} from './style'
import GrowIcon from 'assets/svg/GrowIcon'

interface Props {
  isMobile?: boolean
}

const InvestmentNews: React.FC<Props> = ({ isMobile }) => {
  return (
    <InvestmentCardContainer>
      <InvestmentCardTitle>
        ¡Novedad!
      </InvestmentCardTitle>
      <InvestmentCardSubtitle>
        Invertí y empezá a ganar hoy
      </InvestmentCardSubtitle>
      <InvestmentButton>
        {!isMobile && <GrowIcon />}
        <InvestmentLegend>
          Alta de inversiones exclusivamente en Qira Pagos App
        </InvestmentLegend>
      </InvestmentButton>
    </InvestmentCardContainer>
  )
}

InvestmentNews.defaultProps = {
  isMobile: false
}

export default InvestmentNews
